import { render, staticRenderFns } from "./IconLinkedinLight.vue?vue&type=template&id=66f4dd86&"
import script from "./IconLinkedinLight.vue?vue&type=script&lang=js&"
export * from "./IconLinkedinLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports